import { ComponenteService } from './../../../../service/endereco/componente.service';
import { ComponenteModel } from './../../../../model/endereco/componente.model';
import { Component, Inject, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as CryptoJS from 'crypto-js';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ModuloService } from 'app/service/endereco/modulo.service';
import { TipoCaixaService } from 'app/service/caixa/tipo-caixa.service';
import { UnidadeService } from 'app/service/endereco/unidade.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { TipoComponenteService } from 'app/service/endereco/tipo-componente.service';
import { UnidadeModel } from 'app/model/endereco/unidade.model';
import { TipoComponenteModel } from 'app/model/endereco/tipocomponente.mode';
import { TipoCaixaModel } from 'app/model/caixa/tipocaixa.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@alfresco/adf-core';
import { IActionMapping, ITreeOptions, TreeModel, TREE_ACTIONS } from 'angular-tree-component';

export class QtdAlocavelModel {
  id: Number;
  qtdProfundidade: Number;
  qtdHorizontal: Number;
  qtdVertical: Number;
}

@Component({
  selector: 'app-componentes-filhos',
  templateUrl: './componentes-filhos.component.html',
  styleUrls: ['./componentes-filhos.component.scss']
})
export class ComponentesFilhosComponent implements OnInit, OnChanges {

  options: ITreeOptions = {
    actionMapping: {
      mouse: {
        contextMenu: (tree, node, $event) => {
          $event.preventDefault();
          console.log(tree.focusedNodeId);
          if (tree.focusedNodeId === null) {
            alert('Selecione um componente !');
          } else {
            this.addComponente(tree.focusedNodeId);
          }
          // alert(`Componente: ${node.data.name} / Id: ${node.data.id}`);
        },
        dblClick: (tree, node, $event) => {
          if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
        },
        click: (tree, node, $event) => {
          $event.shiftKey
            ? TREE_ACTIONS.TOGGLE_ACTIVE_MULTI(tree, node, $event)
            : TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
        }
      },
    }
  };

  nodes = [];
  nodesTeste;

  public componente = {} as ComponenteModel;
  public componenteEdit = {} as ComponenteModel;
  public componenteFilhos: ComponenteModel[];
  public filho = {} as ComponenteModel;
  public moduloId;
  public componenteId;
  public deData;
  public horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  public verticalPosition: MatSnackBarVerticalPosition = 'top';
  public listarComponentes = true;
  public addComponentes = false;
  public unidades: UnidadeModel[];
  public tiposComponentes: TipoComponenteModel[];
  public tiposRecipientes: TipoCaixaModel[];
  public qtdComponentes;
  public loading = false;
  public showQtds = false;
  public booleanQtdComponentes = true;
  displayedColumns = ['nome', 'paridade', 'altura', 'largura', 'profundidade', 'posHoriz', 'posVert', 'ativo'];
  dataSource = new MatTableDataSource<ComponenteModel>([]);
  componentesFilhosAny: any[] = [];
  public componenteForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() item = '';
  public toggler;
  public qtdHorizontal = new FormControl();
  public qtdVertical = new FormControl();
  public qtdProfundidade = new FormControl();
  public inputValueQtdHorizontal;
  public inputValueQtdVertical;
  public inputValueQtdProfundidade;
  public ativado;
  public desativado;
  public qtdAlocavel = {} as QtdAlocavelModel;
  public buttonEdit = false;
  public buttonGerarComponentes = true;
  public idComponenteSelecionado;

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private componenteService: ComponenteService,
    private moduloService: ModuloService,
    private tipoCaixaService: TipoCaixaService,
    private unidadeService: UnidadeService,
    private tipoComponenteService: TipoComponenteService) {
      console.log(17);
      this.componenteId = 2;
    }

  ngOnInit() {
    /*this.route.params.subscribe(params => this.componenteId = params['id']);
      this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.componenteId), 'pcdoc');
      this.componenteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));*/
    this.getUnidades();
    this.getTipoRecipientes();
    this.getTipoComponentes();
    this.createForm();
    console.log('item   :', this.item);
  }

  ngOnChanges() {
    this.loading = true;
    this.ativado = false;
    this.desativado = false;
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
    //Write your code here
     console.log(this.item);
     this.getComponenteUnico(this.item);
     this.idComponenteSelecionado = this.item;
    }

  emitirId($event) {
    console.log($event);
  }

  onEvent($event) {
    console.log($event);
  }

  addComponente(componenteId) {
    const dialogRef = this.dialog.open(ComponentesFilhosComponent, {
      width: '100%',
      data: {componenteId: componenteId}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  nodesTree(componenteId) {
    this.componenteService.nodesTree(componenteId).subscribe(data => {
      //console.log(data);
      this.nodesTeste = [data];
      console.log(this.nodesTeste);
    }, err => {
      console.error(err);
    });
  }

  openTree() {
    this.toggler[1].addEventListener('click', function() {
      this.parentElement.getElementsByClassName('.nested').classList.toggle('active');
      this.classList.toggle('caret-down');
    });
  }

  checkCampoNull() {
    this.inputValueQtdHorizontal = this.qtdHorizontal.value;
    this.inputValueQtdVertical = this.qtdVertical.value;
    this.inputValueQtdProfundidade = this.qtdProfundidade.value;
    console.log(this.inputValueQtdHorizontal);
    console.log(this.inputValueQtdVertical);
    console.log(this.inputValueQtdProfundidade);
    if ((this.inputValueQtdHorizontal === null) || (this.inputValueQtdHorizontal === '') || (this.inputValueQtdHorizontal === undefined)) {
      this.inputValueQtdHorizontal = 0;
    }
    if ((this.inputValueQtdVertical === null) || (this.inputValueQtdVertical === '') || (this.inputValueQtdVertical === undefined)) {
      this.inputValueQtdVertical = 0;
    }
    if ((this.inputValueQtdProfundidade === null) || (this.inputValueQtdProfundidade === '') || (this.inputValueQtdProfundidade === undefined)) {
      this.inputValueQtdProfundidade = 0;
    }
   }

  createTreeView(componentePai) {
    this.nodes = [
      {
        id: '',
        name: '',
        children: [ ]
      }
    ];

    let tree = [],
      object = {},
      parent,
      child;

    this.nodes = [
      {
        id: componentePai.id,
        name: componentePai.nome,
        children: []
      }];

    for (let i = 0; i < componentePai.componentesFilhos.length; i++) {
      const filho = componentePai.componentesFilhos[i];
      if (filho !== null) {
        this.nodes[0].children.push({id: filho.id, name: filho.nome, children: [] });
      }
      parent = componentePai.componentesFilhos[i];
      object[parent.id] = parent;
      object[parent.id]['children'] = [];
    }

    for (const id in object) {
      if (object.hasOwnProperty(id)) {
        child = object[id];
        // i made some changes here incase some element is missing so you dont get error and just append th tree insetad
        if (child.parentId && object[child['parentId']]) {
          object[child['parentId']]['children'].push(child);
        } else {
          tree.push(child);
        }
      }
    }
    console.log(this.nodes);

    return tree;
  }

  calcularEspaco() {
    this.componenteEdit = new ComponenteModel();
    this.buttonEdit = false;
    this.buttonGerarComponentes = true;
    const filhos = this.componente.componentesFilhos;
    const alturaPai = this.componente.altura;
    const alocavel = this.componente.isAlocacaoRecipiente;
    console.log(alocavel);
    const qtdFilhos = filhos.length;
    let modulo;
    console.log('qtd de filhos :' + qtdFilhos);
    if (this.componente.modulo != null && this.componente.modulo != undefined) {
      modulo = this.componente.modulo;
    }
    const qtdPrateleiras = modulo.capacidadeVertical;
    console.log(this.componente.modulo);
    //
    if (alocavel === true) {
      this.openSnackBarError('Não é possível cadastrar filhos para este componente, por já ser um componente alocável.');
    } else if ((filhos[0] !== undefined) || (filhos[0] !== undefined)) {
      // const alturaFilho = filhos[0].altura;
      // const qtdFilhos = filhos.length;
      // if (alturaPai > (parseFloat(alturaFilho.toString())  * qtdFilhos)) {
      //   this.addComponenteChange();
      // }
      if (qtdPrateleiras > qtdFilhos) {
        this.addComponenteChange();
      } else {
        this.openSnackBarError('Sem espaço para adicionar componentes !');
      }
    }
     else {
      this.addComponenteChange();
    }
  }

  openEdit() {
    this.componenteEdit = this.componente;
    this.buttonGerarComponentes = false;
    this.buttonEdit = true;
    this.listarComponentes = false;
    this.addComponentes = true;
    if (this.componente.isAlocacaoRecipiente === true) {
      this.getQtdAlocavelPorComponente(this.componente.id);
      this.showQtds = true;
    } else {
      this.showQtds = false;
      this.inputValueQtdHorizontal = 0;
      this.inputValueQtdVertical = 0;
      this.inputValueQtdProfundidade = 0;
    }
  }

  compararTipoComponente(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  compararTipoRecipiente(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  compararUnidade(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  editarComponente() {
    this.checkCampoNull();
    console.log(this.idComponenteSelecionado);
    this.componenteForm.get('id').setValue(this.idComponenteSelecionado);
    this.componenteService.editarComponente(this.componenteForm.value, this.inputValueQtdHorizontal, this.inputValueQtdVertical, this.inputValueQtdProfundidade).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Componente editado com sucesso !');
      this.addComponentes = false;
      this.listarComponentes = true;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar editar o componente !');
      this.addComponentes = false;
      this.listarComponentes = true;
    });
  }

  inativarTodos() {
    this.componenteService.inativarTodosComponentes(this.componente.id).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Componente inativado !');
      this.ativado = false;
      this.desativado = true;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar inativar componentes, pois o mesmo pode possuir recipientes alocados !');
    });
  }

  ativarTodos() {
    this.componenteService.ativarTodosComponentes(this.componente.id).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Componente ativado !');
      this.desativado = false;
      this.ativado = true;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar ativar o componente !');
    });
  }

  getQtdAlocavelPorComponente(componenteId) {
    this.componenteService.getQtdAlocavelPorComponente(componenteId).subscribe(data => {
      console.log(data);
      this.qtdAlocavel = data;
      this.checkCampoNull();
    }, err => {
      console.error(err);
    });
  }

  createForm() {
    this.componenteForm = this.fb.group({
      id: [null],
      nome: [null, Validators.required],
      ativo: [null],
      isAlocacaoRecipiente: [null],
      cor: [null, Validators.required],
      tipoCaixa: [null],
      tipoComponente: [null, Validators.required],
      ordenacao: [null, Validators.required],
      unidade: [null, Validators.required]
    });
  }

  checkValue(event: any) {
    if (event.currentTarget.checked === true) {
      this.showQtds =  true;
    } else {
      this.showQtds =  false;
    }
 }

  onSubmit() {
    this.addComponentesFilhos(this.componente.id, this.componenteForm.value);
  }

  addComponenteFilho(componenteId) {
    const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(componenteId), 'pcdoc').toString());

    this.router.navigate(['componente', idCrypt]);
    this.loading = true;
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  inativarAtivarComponente() {
    this.componenteService.desativarAtivarComponente(this.componente.id).subscribe(data => {
      console.log('ok');
      if (this.ativado) {
        this.openSnackBarSuccess('Componente inativado !');
        this.ativado = false;
        this.desativado = true;
      } else {
        this.openSnackBarSuccess('Componente ativado !');
        this.desativado = false;
        this.ativado = true;
      }
    }, err => {
      console.log(err);
      if (this.ativado) {
        if (err.status === 200) {
          this.openSnackBarSuccess('Componente inativado !');
        }
      } else {
        if (err.status === 200) {
          this.openSnackBarSuccess('Componente ativado !');
        }
      }

    });
  }

  addComponentesFilhos(componentePaiId, componente) {
    this.checkCampoNull();
    this.componenteService.adicionarComponentesFilhos(componentePaiId, componente, this.inputValueQtdHorizontal, this.inputValueQtdVertical, this.inputValueQtdProfundidade).subscribe(data => {
      console.log(data);
      //this.dataSource = new MatTableDataSource(data);
      //this.dataSource.paginator = this.paginator;
      //this.dataSource.sort = this.sort;
      this.openSnackBarSuccess('Componentes gerados com sucesso !');
      this.addComponentes = false;
      this.listarComponentes = true;
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro !');
    });
  }

  getUnidades() {
    this.loading = true;
    this.unidadeService.getUnidades().subscribe(data => {
      this.unidades = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  getTipoComponentes() {
    this.loading = true;
    this.tipoComponenteService.getTipoComponentes().subscribe(data => {
      this.tiposComponentes = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  getTipoRecipientes() {
    this.loading = true;
    this.tipoCaixaService.getTipoCaixasUsuario().subscribe(data => {
      this.tiposRecipientes = data;
    }, err => {
      console.error(err);
    });
  }

  getComponente(moduloId: Number, componenteId: Number) {
    this.componenteService.getComponente(moduloId, componenteId).subscribe(data => {
      this.componenteFilhos = data;
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

  setQtdComponentes() {
    const inputValue = (<HTMLInputElement>document.getElementById('qtdComponentesAdd')).value;
    this.qtdComponentes = inputValue;
    this.booleanQtdComponentes = true;
    console.log(inputValue);
  }

  setQtdComponentesCancel() {
    this.booleanQtdComponentes = false;
  }

  getComponenteUnico(componenteId) {
    this.componenteService.getComponenteUnico(componenteId).subscribe(data => {
      console.log(data);
      this.componente = data;
      if (this.componente.ativo === true) {
        this.ativado = true;
      } else {
        this.desativado = true;
      }
      this.dataSource = new MatTableDataSource(data.componentesFilhos);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = false;
      //this.createTreeView(data);
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  addComponenteChange() {
    this.listarComponentes = false;
    this.addComponentes = true;
  }

  listarComponentesChange() {
    this.addComponentes = false;
    this.listarComponentes = true;
  }

  getFilho(e) {
    console.log('teste');
    console.log(e);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/componente/componentes-filhos/componentes-filhos.component.ts